export default {
  props: {
    item: Object // title, icon, url
  }
}
